module.exports = __webpack_public_path__ + "img/library_tablet.f04f98ba.png";